import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import ToolTip from 'react-portal-tooltip'



class NotreEquipe extends Component {


    render() {



    return (

    <div> 
     <section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/facade.png")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos services</a>/<span>Notre Equipe</span>
                    </div>
                </div>
            </div>
        </section>  

        <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                  <div className="col-md-8">
                     <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Notre Equipe</h3>
                     
                      <div className="">
                        <div className="card-style2 equip">
                           <img src="/assets/img/chart_gab_photos/robert.JPG" className="col-md-6 presiteam img-full team"/>
                           
                            <h5><span className="prenom">Robert</span> Sene</h5>
                          <span className="">Président directeur général</span></div>
                       
                      
                      </div>
                    <div className="row board-member">
                      
                      <div className="col-md-4 col-xl-4 col-lg-6">
                        <div className="card-style2 equip ">
                           <img src="/assets/img/chart_gab_photos/ludo.JPG" className="col-md-6 presiteam img-full team"/>
                            <div className="">
                            <h5><span className="prenom">Ludovic</span> LE GALLEU</h5>
                          <span className="">Directeur des Opérations</span></div>
                       </div>
                      
                      </div>
                      <div className="col-md-4 col-xl-4 col-lg-6">
                        <div className="card-style2 equip ">
                           <img src="/assets/img/chart_gab_photos/blanche.JPG" className="col-md-6 presiteam img-full team"/>
                            <div className="">
                            <h5><span className="prenom">Mame Betty</span> COULIBALY</h5>
                          <span className="">Directrice financière</span></div>
                       </div>
                      
                      </div>
                      <div className="col-md-4 col-xl-4 col-lg-6 marie">
                        <div className="card-style2 equip ">
                           <img src="/assets/img/chart_gab_photos/ps.JPG" className="col-md-6 presiteam img-full team"/>
                            <div className="">
                            <h5><span className="prenom">Penda</span> SAMAKE</h5>
                          <span className="">Directrice des ressources humaines</span></div>
                       </div>
                      
                      </div>
                      {/*<div className="col-md-12 col-xl-6 col-lg-6 marie">
                        <div className="card-style2 equip">
                           <img src="/assets/img/chart_gab_photos/mms.JPG" className="col-md-6 presiteam img-full team"/>
                            <div className="">
                            <h5><span className="prenom">Marie Michelle SARR</span></h5>
                          <span className="">Directrice qualité</span></div>
                       </div>
                      
    </div>*/}
        
        
                  
                  </div>

   
      
        
            
              
              </div>
               <Sidebar/>
            </div>
        
        </div>







  

    

  </section>

  
        <hr/>
    </div>
    )
  }
}
export default NotreEquipe;


// WEBPACK FOOTER //
// ./src/components/equipe.jsx